<template>
	<module flex="flex-between">
		<div class="g-menu">
			<div class="g-menu-list">
				<div v-for="(menu, i) in menuList" :key="i">
					<div class="item">
						<router-link :to="menu.path" :event="menu.children ? '' : 'click'" :class="{'z-active': activeState(menu)}" @click.native="menuHandle(menu)">
							<div class="name flex-center">
								<i class="icon tf" :class="menu.icon"></i>
								<span class="flex-grow">{{menu.name}}</span>
								<i v-if="menu.children" class="angle tf tf-angle-down"></i>
								<ins v-if="menu.icon.includes('message') && messageTotal > 0" class="dot"></ins>
							</div>
						</router-link>
						<ul v-if="menu.children">
							<div v-for="(item, j) in menu.children" :key="j">
								<router-link :to="item.path"><li>{{item.name}}</li></router-link>
							</div>
						</ul>
					</div>
				</div>
			</div>
		</div>
		
		<div class="g-menu-content">
			<c-title>{{compTitle}}</c-title>
			<slot></slot>
		</div>
	</module>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		props: {
			title: String
		},
		
		computed: {
			...mapState(['elder', 'messageTotal']),
			...mapGetters(['menuList']),
			
			activeState(menu) {
				return menu => {
					return menu.children && menu.children.find(item => item.path == this.$route.path);
				}
			},
			
			compTitle() {
				return this.title || this.$route.matched[1].meta.name;
			}
		},
		
		methods: {
			menuHandle(menu) {
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.g-menu {
		width: 190px;
		padding: 30px 0 60px;
		box-shadow: 2px 0 5px 0 rgba(120,120,120,.1);
		
		&-list {
			position: sticky;
			top: 0;
			
			.item {
				.z-active .name {
					color: #1492FF;
				}
					
				.name {
					position: relative;
					height: 44px;
					padding: 0 16px 0 6px;
					font-size: 16px;
					color: #444;
					
					elder({
						height: 50px,
						padding-left: 0,
						font-size: 24px
					})
					
					&:hover {
						color: #1492FF;
					}
					
					.icon {
						width: 26px;
						font-size: 18px;
					
						elder({
							width: 30px,
							font-size: 22px
						})
					}
					
					.angle {
						font-size: 12px;
						
						elder({
							font-size: 16px
						})
					}
					
					.dot {
						position: absolute;
						left: 6.3em;
						top: 50%;
						width: 5px;
						height: 5px;
						border-radius: 100%;
						margin-top: -8px;
						background: #f00;
						
						elder({
							left: 5.7em,
							width: 10px,
							height: 10px,
							margin-top: -12px
						})
					}
				}
				
				ul {
					margin-bottom: 10px;
					
					.z-exact li {
						border-right: 2px solid #1492FF;
						color: #1492FF;
						background: #F1F9FF;
					}
					
					li {
						position: relative;
						padding-left: 32px;
						line-height: 36px;
						font-size: 16px;
						
						elder({
							padding-left: 30px,
							line-height: 44px,
							font-size: 24px
						})
						
						&:hover {
							color: #1492FF;
						}
					}
				}
			}
		}
	
		&-content {
			width: 978px;
			min-height: 500px;
		}
	}
</style>
